import { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import { notify } from '@/utils/notification-bridge';

/**
 * Refetch active queries when the browser comes back online and surface a one-shot snackbar.
 * Mirrors the `online` listener in `components/error-boundary/index.tsx` (which only recovers
 * crashes — this complements it for the rest of the app where queries went stale).
 *
 * Apollo dedupes in-flight queries, so the burst of refetches on reconnect is safe.
 */
export const useOnlineRecovery = (): void => {
  const client = useApolloClient();

  useEffect(() => {
    const handleOnline = () => {
      client.refetchQueries({ include: 'active' }).catch(() => {});
      notify({ visibility: true, message: 'errors.graphql.reconnected' });
    };

    window.addEventListener('online', handleOnline);
    return () => window.removeEventListener('online', handleOnline);
  }, [client]);
};
